module.exports = __webpack_public_path__ + "img/iconfont.4e3b8ab9.svg";